import { DefaultLogoEnum } from "enums/enums"
import { useEffect, useState } from "react"
import { loadLogo } from "utils/utils"

export type DefaultLogoType = 'Gov' | 'Institutes' | 'LocalAuthority'

const defaultLogoDictonary: { [key in DefaultLogoEnum]: DefaultLogoType } = {
    "100000000": "Gov",
    "100000001": "Institutes",
    "100000002": "LocalAuthority",
    "100000003": "Institutes"
}
const useImage = (imageId: string, defaultLogo: DefaultLogoEnum) => {
    const [logo, setLogo] = useState<string>(null)
    useEffect(() => {
        loadLogo(imageId, defaultLogoDictonary[defaultLogo]).then((img) => {
            setLogo(img)
        })
    }, [])
    return { logo }

}

export default useImage;